<template>
  <a-modal
    title="条码打印"
    v-model="visible"
    okText="条码打印"
    cancelText="取消"
    :bodyStyle="{ minHeight: '300px' }"
    width="400px"
    @ok="handleOk"
    @cancel="handleCancel"
    :confirmLoading="confirmLoading"
  >
    <a-form :form="form">
      <a-form-item label v-show="false">
        <a-input v-decorator="['InvCode']" />
      </a-form-item>
      <a-row :gutter="24">
        <a-col :xs="24" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="ASN单号">
            <a-input placeholder="ASN单号" v-decorator="['Code']" :disabled="true" />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码规则">
            <a-select v-decorator="['BarRule']">
              <a-select-option v-for="(item, index, key) in barruleList" :value="item.ruleid" :key="key">{{ item.rulename }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="条码类型">
            <a-select v-decorator="['BarType']">
              <a-select-option v-for="(item, index, key) in bartypeList" :value="item.id" :key="key">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>
<script>
import { getBarRule, queryBarCodes, queryBarCodesLocal } from '@/api/scmApi'
import utoPrint from '../../../../utils/print/utoprint'
export default {
  name: 'ASNCodePrint',
  data() {
    return {
      visible: false,
      form: this.$form.createForm(this),
      U8UserInfo: this.$store.getters.U8UserInfo,
      confirmLoading: false,
      barruleList: [],
      autoid: '',
      bartypeList: [
        { id: 'QR_CODE', text: 'QR_CODE' },
        { id: 'CODE_39', text: 'CODE_39' },
        { id: 'CODE_128', text: 'CODE_128' },
        { id: 'PDF_417', text: 'PDF_417' },
        { id: 'DATA_MATRIX', text: 'DATA_MATRIX' }
      ],
      labelCol: { xs: { span: 24 }, sm: { span: 8 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 16 } }
    }
  },
  methods: {
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      const _that = this
      this.confirmLoading = true
      if (_that.U8UserInfo) {
        _that.form.validateFields((err, values) => {
          if (!err) {
            values['autoid'] = this.autoid
            values['Context'] = JSON.stringify(_that.U8UserInfo)
            let dtf = ''
            if (values.BarType === 'QR_CODE') {
              dtf = 'asncode_qr_code'
            } else if (values.BarType === 'CODE_39') {
              dtf = 'asncode_code_39'
            } else if (values.BarType === 'CODE_128') {
              dtf = 'asncode_code_128'
            } else if (values.BarType === 'PDF_417') {
              dtf = 'asncode_pdf_417'
            } else if (values.BarType === 'DATA_MATRIX') {
              dtf = 'asncode_data_matrix'
            }
            // queryBarCodes 原来掉这个接口
            queryBarCodesLocal(values)
              .then(res => {
                if (res.code === 0 || res.code === '0') {
                  _that.confirmLoading = false
                  _that.visible = false
                  debugger
                  const data = { data: { Master: [], Detail: res.data }, dtf: dtf }
                  utoPrint('', data)
                } else {
                  _that.$message.error(res.msg ? res.msg : '获取条码信息失败!')
                  _that.confirmLoading = false
                }
              })
              .catch(function() {
                _that.$message.error('获取条码信息失败!')
                _that.confirmLoading = false
              })
          }
        })
      } else {
        _that.$message.warn('登录信息已过期,请重新登录!')
      }
    },
    loadInfo(ccode, cinvcode) {
      const _that = this
      getBarRule({ ccode: ccode, cinvcode: cinvcode })
        .then(res => {
          if (res.code === 0 || res.code === '0') {
            _that.barruleList = res.data
            _that.form.setFieldsValue({ BarRule: _that.barruleList[0].ruleid })
            _that.form.setFieldsValue({ BarType: 'QR_CODE' })
          } else {
            _that.$message.error(res.msg)
          }
        })
        .catch(function() {
          _that.$message.error('获取条码规则发生异常!')
        })
    },
    toPrintCode(ccode, cinvcode, autoid) {
      this.autoid = autoid
      const _that = this
      _that.visible = true
      _that.confirmLoading = false
      _that.form.resetFields()
      _that.$nextTick(() => {
        _that.form.setFieldsValue({
          Code: ccode
        })
      })
      _that.loadInfo(ccode, cinvcode)
    }
  }
}
</script>
